<template>
  <main >
    <div class="block--base block--row block--base--no--limit block--md block--margin--auto block--center block--padding-1" >
    <h1>Tutoriels</h1>
    </div>
    <section id="tutos" class="block--base block--with--background block--radius block--row block--md block--margin--auto">
      <template>
        <div class="block-column">
          <ul class="secondary--nav">
            <li v-for="(chapter, index) in list" :key="index" @click="change(index)" :class="{ 'is-active': isActive(chapter.id) }">{{ chapter.title }}</li>
          </ul>
        </div>
        <div class="block-column">
          <h2>{{ current.title }}</h2>
          <embedVideo :code="current.code" v-if="current.code.length" class="video-container" />
        </div>
      </template>
    </section>
  </main>
</template>
<script>
import embedVideo from '@/components/video'

export default {
  name: 'tuto',
  components: {
    embedVideo
  },
  data () {
    return {
      list: [],
      current: {}
    }
  },
  methods: {
    change (i) {
      this.current = this.list[i]
    },
    isActive (id) {
      if (id === this.current.id) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.HTTP(`/api/tutos`).then(r => {
      this.list = r.data
      this.current = r.data[0]
    })
  }
}
</script>
